import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { userOptionSelector } from 'store/auth/selectors';

import { Portal } from 'components/Portal';
import { Loader } from 'components/Loader';
import { Auth } from 'store/auth/actions';

import './style.scss';
import { ModalUserOptionForm } from './components/ModalOptionForm';

const ModalUserOption = ({ onClose }) => {
  const dispatch = useDispatch();
  const userOption = useSelector(userOptionSelector);



  useEffect(() => {
    if (!userOption) {
      dispatch(Auth.getUserOption());
    }
  }, [onClose]);

  return (
    <Portal id="modal-statistic" className="user-option" onClose={onClose}>
      <div className="modal-title-user-option">
        <div className="header-title-user-option"> Настройка отображения карточек на главной</div>
      </div>

      {userOption ? <ModalUserOptionForm userOption={userOption} onClose={onClose} /> : <Loader />}
    </Portal>
  );
};

ModalUserOption.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export { ModalUserOption };
